import { Z_MOBILE_ATTRACT_VISUAL, Z_MOBILE_ATTRACT_TOUCH } from '../../../features/quickstart/config/zIndexLayers';

interface MobileAttractOverlayProps {
  visible: boolean;
  /** Background opacity 0-100 (default 55) */
  backgroundOpacity?: number;
  /** Called on first user interaction to trigger fullscreen + audio */
  onFirstInteraction?: () => void;
}

/**
 * Semi-transparent blur overlay that covers the video area on mobile.
 * Sits between the video (Z_STREAM) and the gamepad (Z_GAMEPAD).
 *
 * When visible, renders a transparent interaction layer (Z_MOBILE_ATTRACT_TOUCH)
 * to capture the first tap for fullscreen activation. Android Chrome requires
 * requestFullscreen() from a real DOM element's event handler -- not from
 * window/document-level listeners, capture-phase handlers, or deep callback chains.
 * After the first tap activates fullscreen, this layer is removed and subsequent
 * taps go directly to the gamepad.
 */
export const MobileAttractOverlay = ({ visible, backgroundOpacity = 55, onFirstInteraction }: MobileAttractOverlayProps) => {
  return (
    <>
      {/* Visual blur overlay - sits between video and gamepad */}
      <div
        className='pointer-events-none fixed inset-0'
        style={{
          zIndex: Z_MOBILE_ATTRACT_VISUAL,
          backgroundColor: `rgba(0, 0, 0, ${backgroundOpacity / 100})`,
          backdropFilter: 'blur(4px)',
          WebkitBackdropFilter: 'blur(4px)',
          opacity: visible ? 1 : 0,
          transition: 'opacity 0.6s ease-out',
        }}
      />
      {/* Transparent interaction layer - captures first tap for fullscreen */}
      {visible && onFirstInteraction && (
        <div
          className='fixed inset-0'
          style={{ zIndex: Z_MOBILE_ATTRACT_TOUCH }}
          onClick={onFirstInteraction}
          onTouchEnd={(e) => {
            e.preventDefault();
            onFirstInteraction();
          }}
        />
      )}
    </>
  );
};
